import type { CityConfig } from "@/pages/city-template/types";

export const syracuseConfig: CityConfig = {
  city: "Syracuse",
  state: "New York",
  stateAbbr: "NY",
  slug: "syracuse",
  route: "/cities/syracuse",
  title: "Emergency & Expedited Passport Syracuse NY | Same Day Passport Syracuse",
  metaDescription:
    "Emergency passport Syracuse NY — same day, 24-hour, and 3-5 day expedited passport processing for Onondaga County. Fast Passport Center serves Syracuse, Liverpool, DeWitt, Fayetteville, and all Central New York communities.",
  h1: "Emergency & Expedited Passport Services in Syracuse, NY",
  heroSubtitle:
    "Syracuse's fast passport solution — from the Salt City to the Finger Lakes. Whether you're flying out of Syracuse Hancock International or Albany, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Syracuse%20New%20York%20skyline%20with%20Carrier%20Dome%20and%20Lake%20Onondaga%20in%20foreground%2C%20modern%20downtown%20buildings%20with%20historic%20architecture%2C%20autumn%20foliage%20colors%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20upstate%20New%20York%20urban%20scene%20with%20water%20and%20university%20campus&width=1600&height=700&seq=ny-syracuse-hero-001&orientation=landscape",
  heroImageAlt: "Syracuse New York skyline with Carrier Dome and Lake Onondaga at golden hour",
  geoPosition: "43.0481; -76.1474",
  geoPlacename: "Syracuse, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~250 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Syracuse", zips: "13201-13210, 13211, 13212, 13214, 13215, 13217, 13218, 13219, 13220, 13224, 13225, 13235, 13244, 13250, 13251, 13252, 13261, 13290" },
    { name: "Liverpool", zips: "13088, 13089, 13090" },
    { name: "DeWitt", zips: "13214, 13224" },
    { name: "Fayetteville", zips: "13066" },
    { name: "Clay", zips: "13041, 13090" },
    { name: "Cicero", zips: "13029, 13039, 13041" },
    { name: "Manlius", zips: "13104" },
    { name: "Camillus", zips: "13031, 13219" },
    { name: "Baldwinsville", zips: "13027" },
    { name: "Oswego", zips: "13126" },
    { name: "Utica", zips: "13501-13505, 13599" },
    { name: "Rome", zips: "13440, 13441, 13442, 13449" },
    { name: "Binghamton", zips: "13901-13905, 13999" },
    { name: "Rochester", zips: "14602-14653, 14692" },
    { name: "Albany", zips: "12201-12250, 12255-12262, 12288" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Syracuse travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Syracuse residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Onondaga & Central NY Region",
      desc: "Syracuse, Liverpool, DeWitt, Fayetteville, and all of Central New York — we serve the entire Finger Lakes and Mohawk Valley region.",
    },
  ],
  testimonials: [
    {
      name: "Michael R.",
      location: "Liverpool, Syracuse",
      rating: 5,
      text: "Had a family emergency in Ireland and needed my passport in 3 days. Fast Passport Center delivered exactly on time. Their Syracuse team was incredibly responsive.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah K.",
      location: "Fayetteville, NY",
      rating: 5,
      text: "Renewed my passport through Fast Passport Center for a Caribbean cruise. Chose the 5-day option and had it back in 4 days. Very thorough document review.",
      service: "Passport Renewal",
    },
    {
      name: "David L.",
      location: "DeWitt, Syracuse",
      rating: 5,
      text: "First-time passport for my entire family. The agent helped us coordinate the acceptance clerk appointments for all four of us. Processed in 5 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "syracuse-1",
      name: "Syracuse Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "Mrs.James Sullivan St",
      city: "Syracuse",
      state: "NY",
      zip: "13202",
      phone: "315-425-2121",
      hours: "Mon-Fri 8:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Downtown Syracuse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Syracuse passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "syracuse-2",
      name: "Liverpool Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "7341 Oswego Road",
      city: "Liverpool",
      state: "NY",
      zip: "13090",
      phone: "315-622-0471",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Liverpool (north Syracuse)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Liverpool, Clay, and north Syracuse residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "syracuse-3",
      name: "DeWitt Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "4725 East Genesee Street",
      city: "DeWitt",
      state: "NY",
      zip: "13214",
      phone: "315-446-0300",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "DeWitt (east Syracuse)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving DeWitt, Fayetteville, and east Syracuse communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Syracuse?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Syracuse residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Syracuse?",
      a: "The Syracuse Main Post Office in downtown is the major Syracuse passport acceptance facility. The Liverpool Post Office on Oswego Road and DeWitt Post Office on East Genesee Street are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Syracuse?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Syracuse, Liverpool, and Onondaga County. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Syracuse?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Syracuse passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Syracuse?",
      a: "The fastest way to renew a passport in Syracuse is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Syracuse?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Syracuse and all Onondaga County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Syracuse?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Syracuse. We serve the Salt City and all of Central New York through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Syracuse", address: "various CVS locations across Syracuse, Liverpool, DeWitt, and Fayetteville", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Syracuse", address: "various Walgreens locations throughout Syracuse and Onondaga County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Syracuse", address: "various UPS Store locations in Syracuse and Liverpool", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Syracuse", address: "various FedEx Office locations across Syracuse and DeWitt", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — Syracuse", address: "various Walmart locations in Syracuse and surrounding suburbs", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Syracuse",
      address: "3530 Erie Boulevard East, Syracuse, NY 13214",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Syracuse DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Liverpool",
      address: "7500 Oswego Road, Liverpool, NY 13090",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Liverpool DMV office serving north Syracuse, Clay, and Cicero residents.",
      featured: false,
    },
    {
      name: "NYS DMV — DeWitt",
      address: "4344 East Genesee Street, DeWitt, NY 13214",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "DeWitt DMV office serving east Syracuse, Fayetteville, and Manlius communities.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "In Syracuse, NY",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Syracuse's primary airport with flights to major U.S. hubs including Atlanta, Chicago, and New York. Perfect for Central New York travelers.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "SYR Airport",
      featured: true,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~95 miles from Syracuse",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region airport with flights to major U.S. and international destinations. Alternative for Syracuse area travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: false,
    },
    {
      code: "ROC",
      name: "Greater Rochester International Airport",
      distance: "~88 miles from Syracuse",
      address: "1200 Brooks Ave, Rochester, NY 14624",
      note: "Upstate New York airport with flights to major U.S. cities. Alternative for Syracuse area travelers heading west.",
      flightUrl: "https://www.flyrga.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Syracuse travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Syracuse residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Syracuse residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Syracuse residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Syracuse, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Syracuse residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Syracuse travelers with immediate departure needs from Syracuse Hancock International or Albany." },
    { name: "Passport Renewal", description: "Fast passport renewal for Syracuse residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Syracuse residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Syracuse residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Syracuse and Onondaga County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Syracuse." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Syracuse travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Syracuse travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Syracuse team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Syracuse address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "Amsterdam", route: "/cities/amsterdam-ny" },
    { name: "Gloversville", route: "/cities/gloversville" },
    { name: "Rome", route: "/cities/rome-ny" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Syracuse and all of Central New York as a remote courier service. We do not have a physical office in Syracuse, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Syracuse area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Syracuse and all of Onondaga County. From the Salt City to the Finger Lakes, from Liverpool to Fayetteville — we serve Central New York with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Syracuse and all surrounding communities across Onondaga County and Central New York. Whether you're in Liverpool, DeWitt, or Fayetteville, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Syracuse customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Syracuse travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Syracuse travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Syracuse. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default syracuseConfig;